import { render, staticRenderFns } from "./SiteRequests.vue?vue&type=template&id=1c375b66"
import script from "./SiteRequests.vue?vue&type=script&lang=js"
export * from "./SiteRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports